var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 13.4333C14.3667 13.4333 13.8 13.6833 13.3667 14.075L7.425 10.6167C7.46667 10.425 7.5 10.2333 7.5 10.0333C7.5 9.83334 7.46667 9.64168 7.425 9.45001L13.3 6.02501C13.75 6.44168 14.3417 6.70001 15 6.70001C16.3833 6.70001 17.5 5.58335 17.5 4.20001C17.5 2.81668 16.3833 1.70001 15 1.70001C13.6167 1.70001 12.5 2.81668 12.5 4.20001C12.5 4.40001 12.5333 4.59168 12.575 4.78334L6.7 8.20835C6.25 7.79168 5.65833 7.53335 5 7.53335C3.61667 7.53335 2.5 8.65001 2.5 10.0333C2.5 11.4167 3.61667 12.5333 5 12.5333C5.65833 12.5333 6.25 12.275 6.7 11.8583L12.6333 15.325C12.5917 15.5 12.5667 15.6833 12.5667 15.8667C12.5667 17.2083 13.6583 18.3 15 18.3C16.3417 18.3 17.4333 17.2083 17.4333 15.8667C17.4333 14.525 16.3417 13.4333 15 13.4333ZM15 3.36668C15.4583 3.36668 15.8333 3.74168 15.8333 4.20001C15.8333 4.65835 15.4583 5.03335 15 5.03335C14.5417 5.03335 14.1667 4.65835 14.1667 4.20001C14.1667 3.74168 14.5417 3.36668 15 3.36668ZM5 10.8667C4.54167 10.8667 4.16667 10.4917 4.16667 10.0333C4.16667 9.57501 4.54167 9.20001 5 9.20001C5.45833 9.20001 5.83333 9.57501 5.83333 10.0333C5.83333 10.4917 5.45833 10.8667 5 10.8667ZM15 16.7167C14.5417 16.7167 14.1667 16.3417 14.1667 15.8833C14.1667 15.425 14.5417 15.05 15 15.05C15.4583 15.05 15.8333 15.425 15.8333 15.8833C15.8333 16.3417 15.4583 16.7167 15 16.7167Z",
    fill: "#343333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cce88a470bafe9e1a65785a46b2a508b.svg";
export { ForwardRef as ReactComponent };